import { render, staticRenderFns } from "./AskOwnerPhone.vue?vue&type=template&id=2670bab6&"
import script from "./AskOwnerPhone.vue?vue&type=script&lang=js&"
export * from "./AskOwnerPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports